import { render, staticRenderFns } from "./new.vue?vue&type=template&id=90ac3cf8&scoped=true&"
import script from "./new.vue?vue&type=script&lang=js&"
export * from "./new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ac3cf8",
  null
  
)

export default component.exports